import { ca } from '@cian/analytics';

export const tackMagazineItemClick = (url: string) => () =>
  ca('event', {
    category: 'Card_KP',
    label: url,
    name: 'oldevent',
    action: 'click_journal_post',
  });
